import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import styled from 'styled-components';
import { useIsAudioOnMute, useIsVideoOnMute, useSetMuteAudio, useSetMuteVideo, useVolumeEffect, } from '../state/mediaState';
import { Button } from './Button';
import { CameraIcon, CaretIcon, MicrophoneIcon } from './Icon';
import { selectDevice } from './popups/DevicePopup';
export function AudioDeviceButton({ mediaStream }) {
    const audioButtonRef = useRef(null);
    const setMuteAudio = useSetMuteAudio();
    const isAudioOnMute = useIsAudioOnMute();
    const volumeIndicatorRef = useRef(null);
    const microphoneSvgRef = useRef(null);
    useVolumeEffect(mediaStream, (volume) => {
        volumeIndicatorRef.current?.style.setProperty('--VolumeIndicator_Value', `${volume}`);
        microphoneSvgRef.current?.style.setProperty('transform', `scale(${1 + 0.1 * volume})`);
    });
    return (_jsxs(DoubleButtonWrap, { children: [_jsx(UnderneathButton, { type: "button", ref: audioButtonRef, onClick: () => {
                    selectDevice('audio', {
                        anchorRef: audioButtonRef,
                    });
                }, children: _jsx(CaretIcon, {}) }), _jsxs(TopButton, { type: "button", kind: isAudioOnMute ? undefined : 'secondary', variant: isAudioOnMute ? undefined : 'dark', shape: "pill", padding: "none", onClick: () => {
                    setMuteAudio((c) => !c);
                }, children: [_jsx(MicrophoneIcon, { svgRef: microphoneSvgRef, muted: isAudioOnMute }), !isAudioOnMute && _jsx(VolumeIndicator, { ref: volumeIndicatorRef })] })] }));
}
export function VideoDeviceButton() {
    const videoButtonRef = useRef(null);
    const setMuteVideo = useSetMuteVideo();
    const isVideoOnMute = useIsVideoOnMute();
    return (_jsxs(DoubleButtonWrap, { children: [_jsx(UnderneathButton, { type: "button", ref: videoButtonRef, onClick: () => {
                    selectDevice('video', {
                        anchorRef: videoButtonRef,
                    });
                }, children: _jsx(CaretIcon, {}) }), _jsx(TopButton, { type: "button", kind: isVideoOnMute ? undefined : 'secondary', variant: isVideoOnMute ? undefined : 'dark', shape: "pill", padding: "none", icon: _jsx(CameraIcon, { muted: isVideoOnMute }), onClick: () => {
                    setMuteVideo((c) => !c);
                } })] }));
}
const TopButton = styled(Button) ``;
const UnderneathButton = styled.button `
    appearance: none;
    width: 100%;
    height: 3.75rem;
    border: 0;
    border-radius: 1.875rem;
    padding: 0;
    padding-left: 1rem;
    background: rgba(255, 255, 255, 0.1);
    align-items: center;
`;
const DoubleButtonWrap = styled.div `
    position: relative;
    width: 3.75rem;

    ${UnderneathButton} {
        display: none;
    }

    @media (min-width: 20rem) {
        width: 6.5rem;

        ${TopButton} {
            position: absolute;
            top: 0;
            right: 0;
        }

        ${UnderneathButton} {
            display: flex;
        }
    }
`;
const VolumeIndicator = styled.div `
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 50%;
    box-shadow: inset 0 0 0 calc(var(--VolumeIndicator_Value, 0) * 0.75rem)
        rgba(255, 255, 255, 0.5);
    transition: 100ms box-shadow;
`;
